import * as Yup from "yup";
import { Formik } from "formik";
import { Box } from "@material-ui/core";
import EditText from "../../components/EditText";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email().required("Email is required"),
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  telephone_number: Yup.string(),
  cellular_number: Yup.string(),
  fax_number: Yup.string(),
  street: Yup.string(),
  city: Yup.string(),
  cap: Yup.string(),
  district: Yup.string(),
  country: Yup.string(),
});

const CreateSupportForm = ({ onSubmit = () => {}, initialValues }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <EditText
            {...props}
            label={t("create_support.first_name")}
            name="first_name"
          />
          <EditText
            {...props}
            label={t("create_support.last_name")}
            name="last_name"
          />
          <EditText {...props} label={t("create_support.email")} name="email" />
          <EditText
            {...props}
            label={t("create_support.username")}
            name="username"
          />
          <EditText
            {...props}
            label={t("create_support.password")}
            name="password"
            type="password"
          />
          <EditText
            {...props}
            label={t("create_support.confirm_password")}
            name="confirm_password"
            type="password"
          />

          <EditText
            {...props}
            label={t("create_support.telephone_number")}
            name="telephone_number"
          />
          <EditText
            {...props}
            label={t("create_support.cellular_number")}
            name="cellular_number"
          />
          <EditText
            {...props}
            label={t("create_support.fax_number")}
            name="fax_number"
          />
          <EditText
            {...props}
            label={t("create_support.street")}
            name="street"
          />
          <EditText {...props} label={t("create_support.city")} name="city" />
          <EditText {...props} label={t("create_support.cap")} name="cap" />
          <EditText
            {...props}
            label={t("create_support.district")}
            name="district"
          />
          <EditText
            {...props}
            label={t("create_support.country")}
            name="country"
          />

          <Box my={2}>
            <Submit {...props} title={t("create_support.save")} />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default CreateSupportForm;
